import React from 'react';
import { Link } from 'react-scroll';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <Link to="hero" smooth={true} duration={500} className="cursor-pointer">
              <h1 className="text-2xl font-display mb-4">
                Amplified<span className="text-accent">SEO</span>
              </h1>
            </Link>
            <p className="mb-6">
              Amplified SEO is an independent SEO agency based in Rochester, Kent that works with 
              businesses across the UK to improve their search engine rankings and grow their online presence.
            </p>
            <div className="flex space-x-4">
              <SocialLink href="https://facebook.com" icon={<FaFacebook />} label="Facebook" />
              <SocialLink href="https://twitter.com" icon={<FaTwitter />} label="Twitter" />
              <SocialLink href="https://linkedin.com" icon={<FaLinkedin />} label="LinkedIn" />
              <SocialLink href="https://instagram.com" icon={<FaInstagram />} label="Instagram" />
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="hero" smooth={true} duration={500} className="hover:text-accent transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="services" smooth={true} duration={500} className="hover:text-accent transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="about" smooth={true} duration={500} className="hover:text-accent transition-colors cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="testimonials" smooth={true} duration={500} className="hover:text-accent transition-colors cursor-pointer">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="contact" smooth={true} duration={500} className="hover:text-accent transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Information</h4>
            <address className="not-italic space-y-2">
              <p>11 Moore Street</p>
              <p>Rochester</p>
              <p>Kent ME2 3BD</p>
              <p className="mt-4">
                <a href="tel:07949248272" className="hover:text-accent transition-colors">
                  Tel: 07949 248 272
                </a>
              </p>
              <p>
                <a href="mailto:info@amplifiedseo.co.uk" className="hover:text-accent transition-colors">
                  info@amplifiedseo.co.uk
                </a>
              </p>
            </address>
          </div>
        </div>
      </div>
      
      <div className="bg-primary-dark py-4">
        <div className="container-custom text-center md:flex md:justify-between text-white/70 text-sm">
          <div>© {currentYear} Amplified SEO. All rights reserved.</div>
          <div className="mt-2 md:mt-0">
            <Link to="hero" smooth={true} duration={500} className="hover:text-accent transition-colors mx-2 cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="hero" smooth={true} duration={500} className="hover:text-accent transition-colors mx-2 cursor-pointer">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const SocialLink = ({ href, icon, label }) => {
  return (
    <a 
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="w-10 h-10 rounded-full bg-primary-light flex items-center justify-center hover:bg-accent transition-colors"
      aria-label={label}
    >
      {icon}
    </a>
  );
};

export default Footer;